import { type FanShopCheckoutOrder } from '@capsicum/common';
import { useMutation } from '@tanstack/react-query';

import { fanShopApi } from '../api';

type UsePlaceOrderQueryProps = {
	deliveryDetails: FanShopCheckoutOrder['deliveryDetails'];
	plannedOrder: FanShopCheckoutOrder['plannedOrder'];
};

export const UsePlaceOrderQueryKey = ['checkout-placeOrder'] as const;

export const usePlaceOrderQuery = () => {
	return useMutation({
		mutationFn: async ({ deliveryDetails, plannedOrder }: UsePlaceOrderQueryProps) =>
			(await fanShopApi).postFanShopOrder({ deliveryDetails, plannedOrder }),
		mutationKey: UsePlaceOrderQueryKey
	});
};
